import { Link } from '@mna/react'

export default ({ align, titleText, linkLocation, linkText }) =>
  <div
    className={
      "standby-page-header standby-page-header-" + align
    }
  >
    <h1 className="standby-page-header-title">{titleText}</h1>
    {linkLocation !== undefined && (
      <Link to={linkLocation}>
        <button className="button standby-button-text standby-button-text-blue">
          {linkText}
        </button>
      </Link>
    )}
  </div>
